import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/index'
import newList from '@/views/news/newsList'
import newsDetail from '@/views/news/newsDetail/detail'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/newsList',
      name: 'newsDetail',
      component: newList
    },
    {
      path: '/newsDetail',
      name: 'newsDetail',
      component: newsDetail
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js